import { MUTATION } from '@skooldio/classroom-frontend-api';

const { syncMyCourses } = MUTATION.Student;

export { syncMyCourses };
